import React from "react"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { BREAKPOINTS } from "@/styles/themeSettings"
import Image from "@/components/common/Image"
import { BUTTON_VARIANTS, ICONS } from "@/constants"
import CommonIcon from "@/components/common/Icon/Icon"
import LinkButton from "@/components/common/Buttons/LinkButton"
import Cross from "../../../../assets/grid_background_icons/Wolontariat_ilustracja_krzyz.svg"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const TilesRectangleGridContainer = styled.div`
	width: 100%;
	position: relative;
	background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor]};
	padding-bottom: ${getCssSizeValue(80, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		padding-bottom: 0;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
	}
`

const ContentContainer = styled(GridContainer)`
	align-items: center;
	min-height: calc(50vw / (4 / 3));
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		min-height: calc((100vw * 3 / 8) / (3 / 4));
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		min-height: calc(50vw / (4 / 3));
	}
`

const InnerContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	align-items: flex-start;

	.heading {
		margin-bottom: ${getCssSizeValue(35, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
			margin-bottom: ${getCssSizeValue(48, BREAKPOINTS.TABLET)};
		}
		@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
			margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)};
		}
	}
`

const ButtonWrapper = styled.div`
	margin-top: ${getCssSizeValue(59, BREAKPOINTS.MOBILE)};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-top: ${getCssSizeValue(53, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		margin-top: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
	}
`

const LeftImageWrapper = styled.div`
	width: 100%;
	position: relative;
	margin-bottom: ${getCssSizeValue(40, BREAKPOINTS.MOBILE)};
	aspect-ratio: 4/3;

	.image {
		width: 100%;
		aspect-ratio: 4/3;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: calc(100vw * 3 / 8);
		position: absolute;
		left: 0;
		top: 0;
		margin-bottom: 0;
		.image {
			aspect-ratio: 3/4;
		}
	}
	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		width: 50vw;
		position: absolute;
		left: 0;
		top: 0;
		.image {
			aspect-ratio: 4/3;
		}
	}
`

const CrossWrapper = styled.div`
	position: absolute;
	z-index: 1;
	width: 38px;
	bottom: -23px;
	left: 50%;
	transform: translateX(-50%);
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		right: -35px;
		bottom: -38px;
		left: unset;
		width: 70px;
		transform: translateX(0);
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 130px;
		left: unset;
		bottom: -65px;
		right: -65px;
	}
`

const Icon = styled(CommonIcon)`
	height: 22px;
	width: 22px;
	margin-left: 10px;

	svg {
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`

const Index = ({ data, tilesModuleId, headerDescription }) => {
	const heading = data?.heading || ""
	const description = data?.description || ""
	const backgroundColor = data?.backgroundColor?.color || null
	const image = data?.image?.image || ""
	const button = data?.button || ""
	return (
		<TilesRectangleGridContainer id={tilesModuleId} backgroundColor={backgroundColor}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<LeftImageWrapper className="col-mobile-4 col-tablet-4 col-desktop-8">
				<Image src={image.url || ""} sizes="100%" fit="cover" alt={image?.alt || "image"} />
				<CrossWrapper>
					<Cross />
				</CrossWrapper>
			</LeftImageWrapper>
			<ContentContainer className="indent-desktop-9 indent-tablet-4 col-mobile-8 col-tablet-4 col-desktop-6">
				<InnerContainer>
					<div className="heading typo-borna typo-borna-91" dangerouslySetInnerHTML={getHtmlFromRedactorField(heading)} />
					<div className="typo-borna typo-borna-11" dangerouslySetInnerHTML={getHtmlFromRedactorField(description)} />
					<ButtonWrapper>
						<LinkButton data={button} variant={BUTTON_VARIANTS.PRIMARY}>
							<Icon name={ICONS.CHEVRON} />
						</LinkButton>
					</ButtonWrapper>
				</InnerContainer>
			</ContentContainer>
		</TilesRectangleGridContainer>
	)
}

export default Index
